import { api } from 'shared/api'
import { RulesSchemas } from 'shared/api/requests/rules/schemas'

export const RulesApi = {
  changeStatus: api.account.createPost({
    url: '/triggerRule/changeStatus',
    schemas: RulesSchemas.setDraftStatus,
  }),
}
